export default __webpack_public_path__ + "static/media/Benutzer.78b64d9f.svg";